import { AvatarBasic, Flex } from '@npco/zeller-design-system'

import { AVATAR_BADGE_SIZE } from 'types/common'

import { Checkbox } from '../../components/Form.styled'
import {
  AccountRowContainer,
  Label,
  LabelContainer,
  SubLabel,
} from './AccountRow.styled'

interface AccountRowProps {
  id: string
  avatarChar: string
  label?: string
  sublabel?: string
  checked?: boolean
  onChange: (e: React.ChangeEvent<any>) => void
}

export const AccountRow = ({
  id,
  avatarChar,
  label,
  sublabel,
  onChange,
  checked = false,
}: AccountRowProps) => {
  return (
    <AccountRowContainer>
      <AvatarBasic
        badgeSize={AVATAR_BADGE_SIZE.SMALL}
        text={avatarChar ?? ''}
      />
      <Flex alignItems="center" width="100%" gridGap="16px" mr="8px">
        <LabelContainer>
          <Label>{label}</Label>
          {sublabel && <SubLabel>{sublabel}</SubLabel>}
        </LabelContainer>
        <Checkbox
          name="accounts"
          value={id}
          checked={checked}
          onChange={onChange}
        />
      </Flex>
    </AccountRowContainer>
  )
}
